import { useEffect } from 'react';
import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import GetIcon from "../../../../utils/Icon";
import printerimg from "../../../../assets/print.png"
import Button from "../../../../Core/Button/Button";
import FormLayoutTwo from "../../../../Core/Layout/FormLayoutTwo";
import { useCreatePurchaseTaxTemplateMutation } from '../../../../store/api/Purchasetax';
import ApiResponseBox from '../../../../Components/ApiResponseBox';
import Tab1 from "./Tab1";
import { usePageState } from "../../../../Hook/usePageState";
function Main() {
    const navigate = useNavigate()
    const [error, setError] = useState('');
    const [ptype, setptype] = useState("Error")
    const [showError, setShowError] = useState(false);
    const [createPurchase] = useCreatePurchaseTaxTemplateMutation();

    const [compname, setname] = useState('')

    const pageStateDefault = {
        tab: 1,
        title: "",
        taxcategory: "",
        company: "",
        defaults: false,
        disabled: false,
        taxes: [{
            charge_type: "",
            account_head: "",
            rate: "",
            tax_amount: "",
            description: ""
        }],

    };

    const [pageState, setPageState] = usePageState(`Create Purchase Taxes and Charges Template`, pageStateDefault);


    const { tab, title, taxcategory, company, defaults, disabled, taxes } = pageState;


    useEffect(() => {
        if (pageState.company) {
            setname(pageState.company);
        }
    }, [pageState.company]);
    const handleSubmit = async () => {
        const payload = { title: pageState.title, company: pageState.company, tax_category: pageState.taxcategory, is_default: pageState.defaults, disabled: pageState.disabled, taxes: taxes };
        try {
            const res = await createPurchase(payload).unwrap();
            setError('Purchase Taxes and Charges Template created successfully!');
            setptype('Success');
            setShowError(true);
            setTimeout(() => {
                navigate('/master/tax/purchase-tax-list')
            }, 3000);
        } catch (error) {
            const parsedMessages = JSON.parse(error.data._server_messages);
            const firstMessageObj = JSON.parse(parsedMessages[0]);
            console.log(firstMessageObj, "errr");
            setError(firstMessageObj.message);
            setptype('Error');
            setptype('Error');
            setShowError(true);
        }
    };

    return (
        <>
            <FormLayoutTwo
                title="New Currency Exchange Details"
                breadcrumbs={[
                    { label: " Currency Exchange Details" },
                    { label: " Currency Exchange Details List", url: "/master/currency-exchange-details/currency-exchange-details-list" }
                ]}
                status={'New'}
                actionButtons={
                    <>

                        <Button
                            className="custom-btn-00989"
                            iconName="LuFilePlus2"
                            style={{ gap: '2px', height: '28px' }}
                            onClick={handleSubmit}
                            iconSize={12}
                        >save
                        </Button>
                        <Button
                            to="/brand/create-brand"
                            className="px-2"
                            imgSrc={printerimg}
                            imgStyle={{ width: '21px' }}
                        />
                    </>
                }
            >
                <div className="" style={{ width: "100%", backgroundColor: "#fff", flexGrow: '1' }}>
                    <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                        <div className="d-flex justify-content-between align-items-end ">
                            <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
                                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                                    <a className={tab == 1 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { setPageState({ ...pageState, tab: 1 }) }} href="javascript:void(0);">
                                        General Details{tab == 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                    </a>
                                </li>
                            </ul>
                            <div className="d-flex align-items-center mb-2 px-3" style={{ gap: "2px", fontSize: '12px' }}>
                                <span style={{ position: "relative", top: "-1px" }}>
                                    <GetIcon className="text-[#4B002B]" iconName="CgAttachment" size={12} />
                                </span>
                                <span className="fw-semibold" style={{ color: "#4B002B" }}>
                                    Attachments
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className=" " style={{ background: '' }}>
                        <div className="row">
                            <div className="col-12">
                                <div>
                                    <Tab1
                                        defaults={{
                                            value: pageState.defaults,
                                            setValue: (val) => setPageState({ ...pageState, defaults: val }),
                                        }}
                                        disabled={{
                                            value: pageState.disabled,
                                            setValue: (val) => setPageState({ ...pageState, disabled: val }),
                                        }}
                                        pageState={pageState}
                                        setPageState={setPageState}
                                        handleChange={(f, v) => setPageState({ ...pageState, [f]: v })}
                                        onInputChange={(f, v) => setPageState({ ...pageState, [f]: v })}
                                        taxes={{
                                            value: pageState.taxes || [],
                                            setValue: (val) =>
                                                setPageState({
                                                    ...pageState,
                                                    taxes: val,
                                                }),
                                        }}
                                        compname={compname} />

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <ApiResponseBox
                    poptype={ptype}
                    show={showError}
                    errorMessage={error}
                    onClose={() => setShowError(false)}
                />
            </FormLayoutTwo>
        </>
    )
}

export default Main
